import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.string.trim";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useRef, useEffect, useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import Autosuggest from 'react-autosuggest';
import { FiSearch } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import { CoreButton } from './../../../core';
import useStore from './../store';
import { schools } from './../../../../data/schools';
/**
 * MenuSearch: Autosuggest search input for header.
 */

var SchoolSearch = function SchoolSearch(_ref) {
  var props = _extends({}, _ref);

  var isLoaded = useRef(false); // Generic store value setter.

  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Active view, different actions depending on this

  var activeView = useStore(function (state) {
    return state.activeView;
  }); // Use active metric to find the SD value for a school.

  var activeMetric = useStore(function (state) {
    return state.activeMetric;
  }); // Track and update active quintiles (if selected school is filtered out)

  var activeQuintiles = useStore(function (state) {
    return state.activeQuintiles;
  }); // Reset viewport to zoom in to school

  var flyToSchool = useStore(function (state) {
    return state.flyToSchool;
  }); // Track intro modal display and update.

  var showIntroModal = useStore(function (state) {
    return state.showIntroModal;
  }); // Tracking autosuggest suggestions

  var _useState = useState([]),
      suggestions = _useState[0],
      setSuggestions = _useState[1];

  var _useState2 = useState(''),
      value = _useState2[0],
      setValue = _useState2[1]; // Tracks school search events.


  var eventSchoolSearch = useStore(function (state) {
    return state.eventSchoolSearch;
  }); // Update the UI according to the context.

  var updateUIWithResult = function updateUIWithResult(suggestion) {
    // console.log('updateUIWithResult, ', suggestion)
    if (activeView === 'map') {
      // console.log('in map view, ', suggestion.suggestion)
      var metric = activeMetric;
      var schoolSD = suggestion.suggestion[metric + '_sd'];

      if (!activeQuintiles[schoolSD]) {
        // School's quintile is disabled, re-enable that quintile.
        var quintiles = activeQuintiles.slice();
        quintiles[schoolSD] = 1;
        setStoreValues({
          activeQuintiles: quintiles
        });
      } // Run fly-to animation.


      flyToSchool(suggestion.suggestion.POINT_Y, suggestion.suggestion.POINT_X);
      setStoreValues({
        flyToSchoolSLN: suggestion.suggestion.SLN
      }); // If intro panel is idsplayed, hide it.

      if (!!showIntroModal) {
        setStoreValues({
          showIntroModal: false
        });
      }

      handleClear();
    }

    if (activeView === 'feeder') {
      // console.log('in feeder view, ', suggestion)
      setStoreValues({
        activeFeeder: suggestion.suggestion.HIGH_SLN,
        feederLocked: true,
        highlightedSchool: suggestion.suggestion.TEA
      });
      handleClear();
    }

    setStoreValues({
      eventSchoolSearch: eventSchoolSearch + 1
    });
  };

  var getSuggestions = function getSuggestions(value) {
    var inputValue = value.trim().toLowerCase();
    var inputLength = inputValue.length;
    return inputLength === 0 ? [] : schools.filter(function (el) {
      return el.SCHOOLNAME.toLowerCase().slice(0, inputLength) === inputValue;
    });
  };
  /**
   * Clear the suggestions list.
   */


  var handleClearRequested = function handleClearRequested() {
    setSuggestions([]);
  };
  /**
   * When item is selected, do something.
   * @param  Object e          Event
   * @param  Object suggestion Object of suggestion nodes
   */


  var handleSelection = function handleSelection(e, suggestion) {
    // console.log('handleSelection, ', e, suggestion)
    updateUIWithResult(suggestion);
  };
  /**
   * When input value changes, reset value
   * @param  Object e        Event
   * @param  String newValue String value of input
   */


  var handleChange = function handleChange(e, _ref2) {
    var newValue = _ref2.newValue; // console.log('handleChange, ', e, newValue)

    setValue(newValue);
  };

  var handleBlur = function handleBlur(e) {// console.log('handleBlur, ', e)
  };

  var handleFetchRequested = function handleFetchRequested(_ref3) {
    var value = _ref3.value; // console.log('handleFetchRequested()')

    setSuggestions(getSuggestions(value));
  };

  var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.SCHOOLNAME;
  };

  var handleClear = function handleClear() {
    // reset value and suggestions
    setValue('');
    setSuggestions([]);
  }; // Use your imagination to render suggestions.


  var renderSuggestion = function renderSuggestion(suggestion) {
    // console.log('renderSuggestion, ', suggestion)
    return /*#__PURE__*/React.createElement("div", {
      id: suggestion.TEA,
      "data-feeder": suggestion.HIGH_SLN
    }, suggestion.SCHOOLNAME);
  };

  var inputProps = {
    value: value,
    // usually comes from the application state
    onChange: handleChange,
    // called every time the input value changes
    onBlur: handleBlur,
    // called when the input loses focus, e.g. when user presses Tab
    type: 'search',
    placeholder: i18n.translate("INPUT_SEARCH"),
    'aria-label': i18n.translate("INPUT_SEARCH")
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "search-autosuggest input-group"
  }, /*#__PURE__*/React.createElement(Autosuggest, {
    suggestions: suggestions,
    onSuggestionSelected: handleSelection,
    onSuggestionsFetchRequested: handleFetchRequested,
    onSuggestionsClearRequested: handleClearRequested,
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: renderSuggestion,
    inputProps: inputProps
  }), /*#__PURE__*/React.createElement(FiSearch, {
    className: "icon-search",
    "aria-hidden": "true",
    style: {
      display: !!value ? 'none' : 'block'
    }
  }), /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_search_clear",
    "aria-label": i18n.translate("BUTTON_SEARCH"),
    onClick: handleClear,
    color: "none",
    className: "button-search-clear",
    style: {
      display: !!value ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement(MdClose, null), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("BUTTON_SEARCH"))));
};

export default SchoolSearch;